"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionsContributionBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../commonFunctions");
var PromotionContributionSection_1 = require("./PromotionContributionSection");
var portal_core_1 = require("@ferry/portal-core");
var PromotionsContributionBanner = /** @class */ (function (_super) {
    __extends(PromotionsContributionBanner, _super);
    function PromotionsContributionBanner(props) {
        return _super.call(this, props) || this;
    }
    PromotionsContributionBanner.prototype.render = function () {
        var isRenewal = (0, commonFunctions_1.isPendingRenewal)(this.props.interaction.status);
        return ((0, jsx_runtime_1.jsx)(portal_core_1.InfoBanner, { wording: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("span", { className: "font-weight-bold", children: [!isRenewal && (0, jsx_runtime_1.jsxs)("div", { children: [" ", this.getGreatNewsWording(), " "] }), (0, jsx_runtime_1.jsx)(PromotionContributionSection_1.PromotionsContributionSection, { interaction: this.props.interaction })] }), !isRenewal && (0, jsx_runtime_1.jsx)("div", { children: "Simply select a cover level that suits your needs to get a quote and get covered for the year." }), isRenewal && (0, jsx_runtime_1.jsxs)("div", { children: ["Changes will apply from your renewal date. For changes starting before your renewal, go to ", (0, jsx_runtime_1.jsx)("a", { className: "font-weight-bold text-decoration-underline", href: "/dashboard/annualMotor/yourCars/".concat(this.props.interaction.agreementNumber), children: "Your car, make changes" }), "."] })] }) }));
    };
    PromotionsContributionBanner.prototype.getGreatNewsWording = function () {
        var isDriveAway = (0, commonFunctions_1.isDriveAwayProduct)(this.props.interaction.product);
        return isDriveAway
            ? "Great news! You're eligible for our annual car insurance."
            : "Great news!";
    };
    return PromotionsContributionBanner;
}(plugin_journey_1.WidgetBase));
exports.PromotionsContributionBanner = PromotionsContributionBanner;
//# sourceMappingURL=PromotionsContributionBanner.js.map